// src/components/TeamTable.js
import React from "react";
import {
  Table,
  TableHeader,
  TableCell,
  ActionButton
} from "../styles/StyledComponents";

import Badge from "../components/Badge";

const TeamTable = ({ teamMembers, onEdit }) =>
  <Table>
    <thead>
      <tr>
        <TableHeader>Nome</TableHeader>
        <TableHeader>Email</TableHeader>
        <TableHeader>Telefone</TableHeader>
        <TableHeader>ID do Empregado</TableHeader>
        <TableHeader>Perfil</TableHeader>
        <TableHeader>Status</TableHeader>
        <TableHeader>Primeiro Acesso</TableHeader>
        <TableHeader>Ações</TableHeader>
      </tr>
    </thead>
    <tbody>
      {teamMembers.map(member =>
        <tr key={member._id}>
          <TableCell>
            {member.name}
          </TableCell>
          <TableCell>
            {member.email}
          </TableCell>
          <TableCell>
            {member.telephone}
          </TableCell>
          <TableCell>
            {member.employeeId}
          </TableCell>
          <TableCell>
            {member.profile}
          </TableCell>
          <TableCell>
            <Badge status={member.status ? "Ativo" : "Inativo"} />
          </TableCell>
          <TableCell>
            {member.firstAccess ? "Sim" : "Não"}
          </TableCell>
          <TableCell>
            <ActionButton onClick={() => onEdit(member)}>Editar</ActionButton>
          </TableCell>
        </tr>
      )}
    </tbody>
  </Table>;

export default TeamTable;
